import styled from 'styled-components';
export const Container = styled.div `
  @apply w-full h-8 flex justify-between items-center p-0 py-5 box-border;
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
  --ggs: 1;

  div[data-role='toolbar-content'] {
    @apply inline-flex box-border justify-end items-center;
  }

  ul[data-role='toolbar-icons'] {
    @apply flex gap-2 list-none m-0 p-0;
  }
`;
